import { computed, getCurrentInstance, ref } from "@vue/composition-api";
import { uniqueId } from "lodash";
export const useCoreInput = ({
  value,
  propId,
  onType = false
} = {}) => {
  const currentInstance = getCurrentInstance();
  const valueModel = computed({
    get() {
      return value == null ? void 0 : value.value;
    },
    set(val) {
      currentInstance == null ? void 0 : currentInstance.emit("update:value", val);
    }
  });
  const hasFocus = ref(false);
  let _onFocus;
  const onFocus = cb => {
    _onFocus = cb;
  };
  const handleBaseFocus = event => {
    hasFocus.value = true;
    _onFocus == null ? void 0 : _onFocus(event);
    currentInstance == null ? void 0 : currentInstance.emit("focus", event);
  };
  let _onBlur;
  const onBlur = cb => {
    _onBlur = cb;
  };
  const handleBaseBlur = event => {
    hasFocus.value = false;
    _onBlur == null ? void 0 : _onBlur(event);
    currentInstance == null ? void 0 : currentInstance.emit("blur", event);
  };
  let _onChange;
  const handleBaseChange = event => {
    _onChange == null ? void 0 : _onChange(event);
    currentInstance == null ? void 0 : currentInstance.emit("change", event);
  };
  let _onInput;
  const handleBaseInput = event => {
    _onInput == null ? void 0 : _onInput(event);
    if (onType) valueModel.value = (event == null ? void 0 : event.target).value;
    currentInstance == null ? void 0 : currentInstance.emit("input", event);
  };
  const onInput = cb => {
    _onFocus = cb;
  };
  let _onKeypressEnter;
  const handleKeypressEnter = event => {
    _onKeypressEnter == null ? void 0 : _onKeypressEnter(event);
    if ((event == null ? void 0 : event.type) === "keypress" && (event == null ? void 0 : event.code) === "Enter") currentInstance == null ? void 0 : currentInstance.emit("enter", event);
  };
  const inputId = computed(() => (propId == null ? void 0 : propId.value) || uniqueId());
  return {
    hasFocus,
    handleBaseFocus,
    handleBaseBlur,
    handleBaseChange,
    handleBaseInput,
    handleKeypressEnter,
    onFocus,
    onBlur,
    onInput,
    valueModel,
    inputId
  };
};